import { type DocumentTableDefinitionText, VerticalAlignment } from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import type { IconDefinition } from '@gitbook/spine-react';

export const verticalAlignmentIcons = {
    top: Icon.AlignItemsTop,
    middle: Icon.AlignItemsMiddle,
    bottom: Icon.AlignItemsBottom,
};

export const horizontalAlignmentIcons = {
    left: Icon.AlignTextLeft,
    center: Icon.AlignTextCenter,
    right: Icon.AlignTextRight,
};

export const horizontalAlignments: Array<{
    label: string;
    value: DocumentTableDefinitionText['textAlignment'];
    icon: IconDefinition;
}> = [
    { label: 'Left', value: 'left', icon: horizontalAlignmentIcons.left },
    { label: 'Center', value: 'center', icon: horizontalAlignmentIcons.center },
    { label: 'Right', value: 'right', icon: horizontalAlignmentIcons.right },
];

export const verticalAlignments: Array<{
    label: string;
    value: VerticalAlignment;
    icon: IconDefinition;
}> = [
    { label: 'Top', value: VerticalAlignment.Top, icon: verticalAlignmentIcons.top },
    { label: 'Middle', value: VerticalAlignment.Middle, icon: verticalAlignmentIcons.middle },
    { label: 'Bottom', value: VerticalAlignment.Bottom, icon: verticalAlignmentIcons.bottom },
];
